import { httpClient } from "@/app/client/httpClient";
import { captureException } from "@/plugins/sentry";

type EventGroup =
  | "analyze_watch_later"
  | "analyze_application_reminder"
  | "analyze_worker_training_content"
  | "analyze_childcare";
type EventDefinition = {
  group: EventGroup;
  types: {
    [key: string]: string;
  };
};

class EventService {
  registerEvent(
    group: EventGroup,
    type: string,
    userKey?: string,
    additionalData?: string
  ) {
    return httpClient.system.event.register_event
      .$post({
        body: {
          group,
          userKey,
          type,
          additionalData
        }
      })
      .catch((err: Error) => {
        // エラーを握りつぶす
        captureException(err);
      });
  }
}
export const eventService = new EventService();

// イベント定義を以下に記載し、利用箇所ではこの定義をimportして利用する
export const AnalyzeWatchLaterEvent: EventDefinition = {
  group: "analyze_watch_later",
  types: {
    viewWatchLaterPage: "view_watch_later_page",
    addOnWatchLaterPage: "add_on_watch_later_page",
    removeOnWatchLaterPage: "remove_on_watch_later_page",
    addOnSearchPage: "add_on_search_page",
    removeOnSearchPage: "remove_on_search_page",
    addOnDetailPage: "add_on_detail_page",
    removeOnDetailPage: "remove_on_detail_page"
  }
};

export const AnalyzeWorkerTrainingContentEvent: EventDefinition = {
  group: "analyze_worker_training_content",
  types: {
    openTrainingContent: "open_training_content"
  }
};

// 前日確認モーダルで使用していたイベント定義
// 前日確認モーダルのデザインが変わったことにより、一旦使用しなくなった
// 今後、同じイベント名で使用したい可能性もあるので、コメントアウトして残しておく
// 一定期間が経過して使用しないことが確定したら削除する
// export const AnalyzeApplicationReminderEvent: EventDefinition = {
//   group: "analyze_application_reminder",
//   types: {
//     viewApplicationReminder: "view_application_reminder",
//     closeApplicationReminder: "close_applicaiton_reminder"
//   }
// };
